var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('b-overlay', {
    attrs: {
      "show": _vm.isLoading
    }
  }, [_c('h4', [_vm._v("點數異動紀錄")]), _vm.upperCustomerId && _vm.availablePoint !== null ? _c('div', {
    staticClass: "font-weight-bold",
    staticStyle: {
      "font-size": "14px"
    }
  }, [_vm._v(" 可用點數 "), _c('span', {
    staticClass: "mdi mdi-help-circle-outline",
    attrs: {
      "id": "availablePointTip"
    }
  }), _vm._v("：" + _vm._s(_vm.availablePoint) + " "), _c('b-tooltip', {
    attrs: {
      "target": "availablePointTip",
      "triggers": "hover"
    }
  }, [_vm._v(" 點數為此會員的總點數（跨通路累積 ")])], 1) : _vm._e(), _c('div', {
    staticClass: "row mx-0 justify-content-between mb-2 mt-3"
  }, [_c('div', [_c('b-button', {
    directives: [{
      name: "b-toggle",
      rawName: "v-b-toggle",
      value: ['collapse-filter'],
      expression: "['collapse-filter']"
    }],
    attrs: {
      "variant": "outline-info"
    }
  }, [_c('span', {
    staticClass: "mdi mdi-magnify"
  }), _vm._v("進階搜尋 ")])], 1), _c('div', [_vm.showAddButton ? _c('b-button', {
    directives: [{
      name: "b-modal",
      rawName: "v-b-modal.modal-add",
      modifiers: {
        "modal-add": true
      }
    }],
    staticClass: "flex-shrink-0 mb-0 ml-2 btn",
    attrs: {
      "variant": "primary"
    }
  }, [_c('i', {
    staticClass: "mdi mdi-plus-circle-outline"
  }), _vm._v(" 手動給點 ")]) : _vm._e(), _vm.showUseButton ? _c('b-button', {
    directives: [{
      name: "b-modal",
      rawName: "v-b-modal.modal-use",
      modifiers: {
        "modal-use": true
      }
    }],
    staticClass: "flex-shrink-0 mb-0 ml-2 btn",
    attrs: {
      "variant": "inverse-primary"
    }
  }, [_c('i', {
    staticClass: "mdi mdi-minus-circle-outline"
  }), _vm._v(" 手動扣點 ")]) : _vm._e(), _vm.showFilter && _vm.query.merchant_id ? _c('b-button', {
    staticClass: "flex-shrink-0 mb-0 ml-2 btn",
    attrs: {
      "variant": "primary"
    },
    on: {
      "click": _vm.handleExport
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  }), _vm._v("匯出 excel ")]) : _vm._e()], 1)]), _c('b-collapse', {
    staticClass: "mt-2",
    attrs: {
      "id": "collapse-filter"
    }
  }, [_c('b-card', [_c('b-form', [_c('div', {
    staticClass: "d-flex flex-column flex-xl-row flex-wrap"
  }, [!_vm.showFilter ? _c('b-form-group', {
    staticStyle: {
      "width": "50%"
    },
    attrs: {
      "label": "通路名稱",
      "label-cols-sm": "3",
      "label-cols-lg": "2",
      "content-cols-sm": "",
      "content-cols-lg": "7"
    }
  }, [_c('AppSingleSelect', {
    attrs: {
      "options": _vm.merchants,
      "disabled": _vm.merchants.length == 2
    },
    on: {
      "input": _vm.onMerchantChange
    },
    model: {
      value: _vm.selectedMerchant,
      callback: function callback($$v) {
        _vm.selectedMerchant = $$v;
      },
      expression: "selectedMerchant"
    }
  })], 1) : _vm._e(), !_vm.showFilter ? _c('b-form-group', {
    staticStyle: {
      "width": "50%"
    },
    attrs: {
      "label": "點數增減",
      "label-cols-sm": "3",
      "label-cols-lg": "2",
      "content-cols-sm": "",
      "content-cols-lg": "7"
    }
  }, [_c('AppSingleSelect', {
    attrs: {
      "options": _vm.typeOptions
    },
    on: {
      "input": _vm.onTypeChange
    },
    model: {
      value: _vm.selectedType,
      callback: function callback($$v) {
        _vm.selectedType = $$v;
      },
      expression: "selectedType"
    }
  })], 1) : _vm._e(), _vm.showFilter ? _c('b-form-group', {
    staticStyle: {
      "width": "50%"
    },
    attrs: {
      "label": "分店名稱",
      "label-cols-sm": "3",
      "label-cols-lg": "2",
      "content-cols-sm": "",
      "content-cols-lg": "7"
    }
  }, [_c('AppSingleSelect', {
    attrs: {
      "options": _vm.branchOptions,
      "disabled": _vm.disabledBranchSelect
    },
    on: {
      "input": _vm.branchChange
    },
    model: {
      value: _vm.selectedBranch,
      callback: function callback($$v) {
        _vm.selectedBranch = $$v;
      },
      expression: "selectedBranch"
    }
  })], 1) : _vm._e(), _vm.showFilter ? _c('b-form-group', {
    staticStyle: {
      "width": "50%"
    },
    attrs: {
      "label": "點數增減",
      "label-cols-sm": "3",
      "label-cols-lg": "2",
      "content-cols-sm": "",
      "content-cols-lg": "7"
    }
  }, [_c('AppSingleSelect', {
    attrs: {
      "options": _vm.typeOptions
    },
    on: {
      "input": _vm.onTypeChange
    },
    model: {
      value: _vm.selectedType,
      callback: function callback($$v) {
        _vm.selectedType = $$v;
      },
      expression: "selectedType"
    }
  })], 1) : _vm._e(), _vm.showFilter ? _c('b-form-group', {
    staticStyle: {
      "width": "50%"
    },
    attrs: {
      "label": "異動來源",
      "label-cols-sm": "3",
      "label-cols-lg": "2",
      "content-cols-sm": "",
      "content-cols-lg": "7"
    }
  }, [_c('AppSingleSelect', {
    attrs: {
      "options": _vm.sourceOptions
    },
    on: {
      "input": _vm.onSourceChange
    },
    model: {
      value: _vm.selectedSource,
      callback: function callback($$v) {
        _vm.selectedSource = $$v;
      },
      expression: "selectedSource"
    }
  })], 1) : _vm._e(), _vm.showFilter ? _c('b-form-group', {
    staticStyle: {
      "width": "50%"
    },
    attrs: {
      "label": "活動代碼",
      "label-cols-sm": "3",
      "label-cols-lg": "2",
      "content-cols-sm": "",
      "content-cols-lg": "7"
    }
  }, [_c('event-select', {
    on: {
      "change": _vm.handlePageReset
    },
    model: {
      value: _vm.query.event_id,
      callback: function callback($$v) {
        _vm.$set(_vm.query, "event_id", $$v);
      },
      expression: "query.event_id"
    }
  })], 1) : _vm._e(), _vm.showFilter ? _c('b-form-group', {
    staticStyle: {
      "width": "50%"
    },
    attrs: {
      "label": "通路名稱",
      "label-cols-sm": "3",
      "label-cols-lg": "2",
      "content-cols-sm": "",
      "content-cols-lg": "7"
    }
  }, [_c('AppSingleSelect', {
    attrs: {
      "options": _vm.merchants,
      "disabled": _vm.merchants.length == 2
    },
    on: {
      "input": _vm.onMerchantChange
    },
    model: {
      value: _vm.selectedMerchant,
      callback: function callback($$v) {
        _vm.selectedMerchant = $$v;
      },
      expression: "selectedMerchant"
    }
  })], 1) : _vm._e()], 1)])], 1)], 1), _vm.showFilter && _vm.query.merchant_id ? _c('b-card', {
    staticClass: "mt-2"
  }, [_c('b-input-group', [_c('b-form-input', {
    staticStyle: {
      "max-width": "500px"
    },
    attrs: {
      "placeholder": "搜尋會員名稱、手機、外部編碼"
    },
    on: {
      "keyup": function keyup($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.handleSearch.apply(null, arguments);
      }
    },
    model: {
      value: _vm.query.keyword,
      callback: function callback($$v) {
        _vm.$set(_vm.query, "keyword", $$v);
      },
      expression: "query.keyword"
    }
  }), _c('b-input-group-append', [_c('b-button', {
    on: {
      "click": _vm.handleSearch
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  })])], 1)], 1)], 1) : _vm._e(), _c('b-table', {
    attrs: {
      "striped": "",
      "hover": "",
      "responsive": "",
      "items": _vm.pointLogs,
      "fields": _vm.filteredFields,
      "no-local-sorting": true
    },
    on: {
      "sort-changed": _vm.handleSort
    },
    scopedSlots: _vm._u([{
      key: "table-busy",
      fn: function fn() {
        return [_c('div', {
          staticClass: "text-center my-2"
        }, [_c('b-spinner', {
          staticClass: "align-middle"
        })], 1)];
      },
      proxy: true
    }, {
      key: "cell(batch_total_points)",
      fn: function fn(data) {
        return [_c('span', {
          style: {
            color: data.item.batch_total_points < 0 ? '#ff6258' : 'inherit'
          }
        }, [_vm._v(" " + _vm._s(data.item.batch_total_points) + " ")])];
      }
    }, {
      key: "cell(customer_name)",
      fn: function fn(data) {
        return [_vm._v(" " + _vm._s(_vm._f("hiddenString")(data.item.customer_name, 20)) + " ")];
      }
    }, {
      key: "cell(created_at)",
      fn: function fn(data) {
        return [_vm._v(" " + _vm._s(_vm.formatDate(data.item.created_at)) + " ")];
      }
    }, {
      key: "cell(expired_at)",
      fn: function fn(data) {
        return [_vm._v(" " + _vm._s(_vm.showExpiredAt(data.item)) + " ")];
      }
    }, {
      key: "cell(actions)",
      fn: function fn(data) {
        return [_c('b-button', {
          staticClass: "ml-2",
          attrs: {
            "variant": "inverse-info",
            "to": {
              name: 'PointDetail',
              params: {
                pointLogId: data.item.id
              }
            }
          }
        }, [_vm._v("查看點數內容")])];
      }
    }])
  }), _c('CustomPagination', {
    attrs: {
      "currentPage": _vm.query.page,
      "totalRows": _vm.total,
      "perPage": _vm.query.per_page
    },
    on: {
      "page-change": _vm.handlePageChange,
      "per-page-change": _vm.handlePerPageChange
    }
  }), _c('b-modal', {
    attrs: {
      "id": "modal-use",
      "title": "要扣除多少點數？"
    },
    on: {
      "show": _vm.resetPointForUse
    },
    scopedSlots: _vm._u([{
      key: "modal-footer",
      fn: function fn(_ref) {
        var cancel = _ref.cancel;
        return [_c('b-button', {
          staticClass: "float-right",
          attrs: {
            "variant": "outline-danger",
            "size": "sm"
          },
          on: {
            "click": function click($event) {
              return cancel();
            }
          }
        }, [_vm._v(" 關閉 ")]), _c('b-button', {
          attrs: {
            "size": "sm",
            "variant": "outline-primary",
            "disabled": _vm.isSubmittingUse
          },
          on: {
            "click": _vm.usePoint
          }
        }, [_vm._v(" 確定 ")])];
      }
    }])
  }, [_c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "點數"
    }
  }, [_c('b-form-input', {
    staticClass: "mb-2 mr-sm-2 mb-sm-0",
    attrs: {
      "placeholder": "輸入10 (將扣除10點) "
    },
    model: {
      value: _vm.pointForUse.point,
      callback: function callback($$v) {
        _vm.$set(_vm.pointForUse, "point", $$v);
      },
      expression: "pointForUse.point"
    }
  })], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "說明"
    }
  }, [_c('b-form-input', {
    staticClass: "mb-2 mr-sm-2 mb-sm-0",
    model: {
      value: _vm.pointForUse.description,
      callback: function callback($$v) {
        _vm.$set(_vm.pointForUse, "description", $$v);
      },
      expression: "pointForUse.description"
    }
  })], 1)], 1), _c('b-modal', {
    attrs: {
      "id": "modal-add",
      "title": "請問要增加多少點？"
    },
    on: {
      "show": _vm.resetPoint
    },
    scopedSlots: _vm._u([{
      key: "modal-footer",
      fn: function fn(_ref2) {
        var cancel = _ref2.cancel;
        return [_c('b-button', {
          staticClass: "float-right",
          attrs: {
            "variant": "outline-danger",
            "size": "sm"
          },
          on: {
            "click": function click($event) {
              return cancel();
            }
          }
        }, [_vm._v(" 關閉 ")]), _c('b-button', {
          attrs: {
            "size": "sm",
            "variant": "outline-primary",
            "disabled": _vm.isSubmittingAdd
          },
          on: {
            "click": _vm.addPoint
          }
        }, [_vm._v(" 確定 ")])];
      }
    }])
  }, [_c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "點數"
    }
  }, [_c('b-form-input', {
    staticClass: "mb-2 mr-sm-2 mb-sm-0",
    model: {
      value: _vm.point.point,
      callback: function callback($$v) {
        _vm.$set(_vm.point, "point", $$v);
      },
      expression: "point.point"
    }
  })], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "說明"
    }
  }, [_c('b-form-input', {
    staticClass: "mb-2 mr-sm-2 mb-sm-0",
    model: {
      value: _vm.point.description,
      callback: function callback($$v) {
        _vm.$set(_vm.point, "description", $$v);
      },
      expression: "point.description"
    }
  })], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "開始時間"
    }
  }, [_c('div', {
    staticClass: "d-flex align-items-center"
  }, [_c('datepicker', {
    staticClass: "mr-2",
    staticStyle: {
      "flex": "1"
    },
    attrs: {
      "placeholder": "選擇日期",
      "bootstrap-styling": "",
      "format": "yyyy-MM-dd",
      "language": _vm.zh,
      "clear-button": "",
      "typeable": true
    },
    model: {
      value: _vm.point.start_at_date,
      callback: function callback($$v) {
        _vm.$set(_vm.point, "start_at_date", $$v);
      },
      expression: "point.start_at_date"
    }
  }), _c('vue-timepicker', {
    staticStyle: {
      "width": "120px"
    },
    attrs: {
      "placeholder": "選擇時間",
      "format": "HH:mm",
      "input-class": ['form-control', 'text-center'],
      "clearable": ""
    },
    nativeOn: {
      "keyup": [function ($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "delete", [8, 46], $event.key, ["Backspace", "Delete", "Del"])) { return null; }
        _vm.point.start_at_time = {
          HH: '',
          mm: ''
        };
      }, function ($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "backspace", undefined, $event.key, undefined)) { return null; }
        _vm.point.start_at_time = {
          HH: '',
          mm: ''
        };
      }]
    },
    model: {
      value: _vm.point.start_at_time,
      callback: function callback($$v) {
        _vm.$set(_vm.point, "start_at_time", $$v);
      },
      expression: "point.start_at_time"
    }
  })], 1)]), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "過期時間"
    }
  }, [_c('div', {
    staticClass: "d-flex align-items-center"
  }, [_c('datepicker', {
    staticClass: "mr-2",
    staticStyle: {
      "flex": "1"
    },
    attrs: {
      "placeholder": "選擇日期",
      "bootstrap-styling": "",
      "format": "yyyy-MM-dd",
      "language": _vm.zh,
      "clear-button": "",
      "typeable": true
    },
    model: {
      value: _vm.point.expired_at_date,
      callback: function callback($$v) {
        _vm.$set(_vm.point, "expired_at_date", $$v);
      },
      expression: "point.expired_at_date"
    }
  }), _c('b-form-input', {
    staticClass: "bg-light text-center",
    staticStyle: {
      "width": "120px"
    },
    attrs: {
      "value": _vm.point.expired_at_date ? '23:59' : '',
      "readonly": "",
      "disabled": ""
    }
  })], 1)])], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }